import { defineMessages } from "react-intl";

export const messages = defineMessages({
  titleLabel: {
    id: "previewMicrophoneCard.title.label",
    defaultMessage: "Microphone",
    description: "Title label in preview room",
  },
  content: {
    id: "previewMicrophoneCard.content.text",
    defaultMessage:
      "Try to talk into your microphone. When you do, the dark area located in the top right of your video screen should become green and react with the volume of your voice.",
    description: "Content text",
  },
  errorContent: {
    id: "previewMicrophoneCard.content.error.text",
    defaultMessage: "Microphone permission needs to be granted",
    description: "Error content text",
  },
  errorNoDeviceFound: {
    id: "previewMicrophoneCard.content.error.noDevice.text",
    defaultMessage: "No audio device could be found.",
    description: "Error content text when no audio device found",
  },
  audioSourceLabel: {
    id: "previewMicrophoneCard.field.audioSource.label",
    defaultMessage: "Audio Source",
    description: "Label for audio source field",
  },
  showHowButtonLabel: {
    id: "previewMicrophoneCard.button.showHow.label",
    defaultMessage: "Show how",
    description: "Label show how button",
  },
});
